import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import {
	Form,
	Modal,
	Spin
} from 'antd';
import { useEffect, useState } from 'react';
import FormItemInput from '../../../../../components/form-input/FormInput';
import { getFolderDetail } from '../../../../../service/learning-material';

interface Props {
	open: boolean;
	handleClose: () => void;
	onSubmit?: (values: any) => void;
	folderId: any;
}

export default function CreateFolderModal({
	open,
	handleClose,
	onSubmit,
	folderId,
}: Props) {
  const { t } = useTranslation();
	const [form] = Form.useForm();
	const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (!open) return;
		form.resetFields();
		setSelectedUsers([]);

		const loadFolder = async () => {
			setIsLoading(true);
			try {
				const res = await getFolderDetail(folderId);
				const data = res.data.data;

				form.setFieldsValue({
					name: data.name,
				});

				const formattedUsers = data.authors.map((u: any) => ({
					id: u.userId,
					email: u.email,
					name: u.userName,
					permission: u.permission,
					universityMember: u.universityMember,
					university: u.university,
					avatar: u.avatar,
				}));

				setSelectedUsers(formattedUsers);
			} catch (error) {
				console.error(t('Lỗi khi lấy chi tiết thư mục:', 'Lỗi khi lấy chi tiết thư mục:'), error);
			} finally {
				setIsLoading(false);
			}
		};

		if (folderId) {
			loadFolder();
		} else {

		}
	}, [open, folderId]);

	return (
		<Modal
			open={open}
			title={folderId ? t("Chỉnh sửa thư mục", "Chỉnh sửa thư mục") : t("Thêm mới thư mục", "Thêm mới thư mục")}
			width={600}
			onCancel={handleClose}
			onOk={() => form.submit()}
			confirmLoading={isLoading}
			destroyOnClose
			okText={t("Lưu", "Lưu")}
			cancelText={t("Hủy", "Hủy")}
			maskClosable={false}
			centered
		>
			<Spin spinning={isLoading}>
				<Form
					form={form}
					layout="vertical"
					onFinish={(values) => onSubmit?.({ ...values, users: selectedUsers })}				>
					<Form.Item
						name="name"
						label={t("Tên thư mục", "Tên thư mục")}
						rules={[{ required: true, message: t('Vui lòng nhập tên thư mục', 'Vui lòng nhập tên thư mục') }]}
					>
						<FormItemInput placeholder={t("Nhập tên thư mục", "Nhập tên thư mục")} />
					</Form.Item>

					<div className="hr-tag" />

					{/* <SharedAccessSection
						form={form}
						selectedUsers={selectedUsers}
						setSelectedUsers={setSelectedUsers}
						authorizedUsers={authorizedUsers}
						isMine={isMine}
						isEdit={!!folderId}
					/> */}
				</Form>
			</Spin>
		</Modal>
	);
}
